
<p-fieldset>
    <p-header class="article-title">
        <span class="article-title">{{'TITLE-PACKAGE-MANAGER' | translate}}</span>
        <div class="header-buttons">
           <button class="fab-button outline" appFiltersButton pTooltip="Exibir/Ocultar Filtros" tooltipPosition="left">
                <i class="pi pi-filter"></i>
            </button>
        </div>
    </p-header>
    <form class="filters" (submit)="find()" appFilters>
        <div class="filter-row">
            <div class="form-control">
                <label for="boatId">{{'BOAT' | translate}}</label>
                <p-dropdown [options]="boats" [(ngModel)]="packageFilter.boatId" name="boatId" [filter]="true"
                    filterBy="label" [placeholder]="'BOATS' | translate" appendTo="body">
                </p-dropdown>
            </div>
            <div class="form-control">
                <label for="customerId">{{'CUSTOMER' | translate}}</label>
                <p-dropdown [options]="customers" [(ngModel)]="packageFilter.customerId" name="customerId" [filter]="true"
                    filterBy="label" [placeholder]="'CUSTOMERS' | translate" appendTo="body">
                </p-dropdown>
            </div>
            <div class="form-control">
                <label for="packageServiceId">{{'SERVICE-PACKAGE' | translate}}</label>
                <p-dropdown [options]="packageServices" [(ngModel)]="packageFilter.packageServiceId" name="packageServiceId" [filter]="true"
                    filterBy="label" [placeholder]="'SERVICE-PACKAGE' | translate" appendTo="body">
                </p-dropdown>
            </div>
            <div class="form-control">
                <label for="packageStatus">Status</label>
                <p-multiSelect [options]="statusOptions" [(ngModel)]="packageFilter.packageStatus" name="packageStatus" 
                    [filter]="false" defaultLabel="Todos" selectedItemsLabel="{0} status selecionados"
                    [maxSelectedLabels]="3" appendTo="body">
                </p-multiSelect>
            </div>
            <div class="form-control">
                <label for="startDate">{{'START-DATE' | translate}}</label>
                <p-calendar [(ngModel)]="packageFilter.startDate" name="startDate" [showIcon]="true"
                    dateFormat="dd/mm/yy" [placeholder]="'START-DATE' | translate" appendTo="body" [maxDate]="packageFilter.endDate">
                </p-calendar>
            </div>
            <div class="form-control">
                <label for="endDate">{{'END-DATE' | translate}}</label>
                <p-calendar [(ngModel)]="packageFilter.endDate" name="endDate" [showIcon]="true"
                    dateFormat="dd/mm/yy" [placeholder]="'END-DATE' | translate" appendTo="body" [minDate]="packageFilter.startDate">
                </p-calendar>
            </div>
            <br/>

        </div>
        <div clas="buttons-container">
            <div class="buttons">
              <p-button label="{{ 'CLEAR' | translate }}" styleClass="p-button-outlined p-button-secondary m-3" (click)="clear()"></p-button>
              <p-button label="{{ 'APPLY-FILTER' | translate }}" type="submit"></p-button>
            </div>
            <div class="d-flex flex-row justify-content-end mb-2" style="margin-top: 10px; margin-right: 20px; ">
                <p-button label="+ Novo Pedido de Pacote" styleClass="p-button-success" (click)="openServicePackageOrderDialog()"></p-button>
            </div>
        </div>

    </form>
</p-fieldset>

    <div class="package-cards-container" style="width: 95vw; margin: 0 auto;">
        <div class="total-info" *ngIf="hasSearched && !noResults">
            <div class="total-registers-container">
                <span class="total-registers">{{ 'TOTAL-REGISTERS' | translate }}:
                    {{servicePackageOrders.length}} {{'OF' | translate}} {{totalRecords}}
                </span>
            </div>
            <!-- <p-button
                label="Download"
                icon="pi pi-download"
                styleClass="p-button-outlined p-button-secondary mr-2 mb-2">
            </p-button> -->
        </div>

        <div class="package-cards" *ngIf="hasSearched && !noResults">
            <ng-container *ngFor="let barco of servicePackageOrders">
                <div class="package-card" *ngFor="let pacoteServico of barco.pacotesServico">
                    <div class="card-header" style="display: flex; justify-content: space-between; align-items: center;">
                        <div class="boat-info">
                            <h2 class="boat-name">Embarcação: <span style="color: var(--primary-color);">"{{barco.nome}}"</span></h2>
                            <div class="package-name">Pacote: {{pacoteServico.nomePacote}}</div>
                        </div>
                        <div class="package-header-info" style="display: flex; gap: 20px;">
                            <div class="validity">
                                <span class="label">Vigência:</span>
                                <span class="dates">{{pacoteServico.dataInicioValidade | date: 'dd/MM/yyyy'}} - {{pacoteServico.dataFimValidade | date: 'dd/MM/yyyy'}}</span>
                            </div>
                            <div class="total-value">
                                <div>
                                    <span class="label-total">Valor Total:</span>
                                <span class="value" style="color: var(--primary-color);">{{getTotalGeralComDesconto(pacoteServico) | currency: 'BRL'}}</span>
                                <ng-container *ngIf="getExcedentTotal(pacoteServico) > 0">
                                    <span class="excedent-info">(Inclui excedente de {{getExcedentTotal(pacoteServico) | currency: 'BRL'}})</span>
                                </ng-container>
                                </div>

                            </div>
                        </div>
                        <div class="status-indicator">
                            <button pButton type="button" 
                                [ngClass]="getStatusClass(pacoteServico.packageStatus)"
                                class="status-button">
                                <i class="{{getStatusIcon(pacoteServico.packageStatus)}}"></i>
                                <span class="status-text">{{getStatusLabel(pacoteServico.packageStatus)}}</span>
                            </button>
                        </div>
                        <div class="actions" *ngIf="pacoteServico.packageStatus === 'active'">
                            <p-menu appendTo="body" #menu [model]="menuItems" [popup]="true" [showTransitionOptions]="'150ms'"
                                [hideTransitionOptions]="'150ms'"></p-menu>
                            <button (click)="menu.toggle($event); changeSelectedPackage(barco, pacoteServico)" pButton type="button" icon="pi pi-ellipsis-v"
                                class="p-button-text p-button-rounded"></button>
                        </div>
                    </div>

                    <div class="package-items" *ngIf="pacoteServico.itens && pacoteServico.itens.length > 0">
                        <table class="items-table">
                            <thead>
                                <tr>
                                    <th style="width: 40vw;">Serviço Incluso</th>
                                    <th style="width: 50vw;">Uso</th>
                                    <th style="width: 8vw; text-align: center;">Restante</th>
                                    <th style="width: 5vw; text-align: center;">Excedente</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of pacoteServico.itens">
                                    <td>{{item.productName}}</td>
                                    <td>
                                        <div class="usage-info">
                                            <span class="usage-text">{{item.qtdUsed}}/{{item.quantity}}</span>
                                            <div class="progress-container">
                                                <div class="progress-bar"
                                                    [ngClass]="{
                                                        'normal': item.qtdUsed < item.quantity,
                                                        'complete': item.qtdUsed === item.quantity,
                                                        'exceeded': item.qtdUsed > item.quantity
                                                    }"
                                                    [style.width.%]="(item.qtdUsed / item.quantity) * 100 > 100 ? 100 : (item.qtdUsed / item.quantity) * 100">
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="text-align: center;" [ngStyle]="{'color': item.remainingBalance > 0 ? '#4CAF50' : ''}">
                                        {{item.remainingBalance}}
                                    </td>
                                    <td style="text-align: center;">
                                        <span *ngIf="item.qtdUsed > item.quantity">
                                            {{(item.qtdUsed - item.quantity) * item.unitValue | currency: 'BRL'}}
                                        </span>
                                        <span *ngIf="item.qtdUsed <= item.quantity">-</span>
                                    </td>

                                </tr>
                            </tbody>
                            <tfoot>

                            </tfoot>
                        </table>
                    </div>
                </div>
            </ng-container>
        </div>

        <div *ngIf="!hasSearched" class="empty-state-message">
            <div class="message-container">
                <i class="pi pi-search" style="font-size: 3rem"></i>
                <h3>Adicione algum filtro, ou apenas clique em 'Aplicar Fltros' para exibir os dados</h3>
            </div>
        </div>

        <div *ngIf="hasSearched && noResults" class="empty-state-message">
            <div class="message-container">
                <i class="pi pi-info-circle" style="font-size: 3rem"></i>
                <h3>Nenhum resultado foi encontrado</h3>
            </div>
        </div>

        <!-- Paginação -->
        <div class="pagination-container" *ngIf="hasSearched && !noResults">
            <p-paginator
                [rows]="packageFilter.size"
                [totalRecords]="totalRecords"
                [alwaysShow]="true"
                [rowsPerPageOptions]="[10, 20, 50, 100]"
                [first]="packageFilter.page * packageFilter.size"
                (onPageChange)="onChangePage($event)">
            </p-paginator>
        </div>
    </div>
